import React from 'react'

const Message = ({sender, text}) => {
  const align = sender === 'user' ? 'right' : 'left';
  return (
    <div style={{textAlign: align}}>
      <p>{text}</p>
    </div>
  )
}

export default Message
